import {Component, Input} from '@angular/core';
import {CardModule} from 'primeng/card';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

@Component({
  selector: 'app-general-capacity',
  standalone: true,
  imports: [
    CardModule,
    CommonModule,
    RouterModule
  ],
  templateUrl: './general-capacity.component.html',
  styleUrls: ['./general-capacity.component.scss'],
})
export class GeneralCapacityComponent {
  @Input() title: string = 'Agent';
  @Input() description: string = 'Communicate with your customers and prospects';
  @Input() icon: string = 'pi pi-headset'; // Default icon
  @Input() link: string = '/';             // Default link (optional)
}
